
import { getRandomIntIncl } from './common';
import { getGame } from '../firebase';

import adjectives from '../assets/adjectives.json';
import animals from '../assets/animals.json';
import gameIDWords from '../assets/game-id-words.json';

export async function generateGameName() {
  const attemptsPerWordCount = 5;
  
	for (let iAttempt = 1; ; iAttempt++) {
    const wordCount = 2 + Math.floor(iAttempt / attemptsPerWordCount);

		let words = [];
		for (let iWord = 0; iWord < wordCount; iWord++) {
			const word = gameIDWords[getRandomIntIncl(0, gameIDWords.length-1)];
			words.push(word);
		}

    const autogeneratedGameName = words.join('-');

    const game = await getGame(autogeneratedGameName);
    if (!game.exists) return autogeneratedGameName;
  }
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateUserName() {
  const adjective = adjectives[getRandomIntIncl(0, adjectives.length-1)];
  const animal = animals[getRandomIntIncl(0, animals.length-1)];
  return `${capitalizeFirstLetter(adjective)} ${capitalizeFirstLetter(animal)}`;
}
